import { render, staticRenderFns } from "./PropstackFilter.vue?vue&type=template&id=840d068c&"
import script from "./PropstackFilter.vue?vue&type=script&lang=js&"
export * from "./PropstackFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports